import React, {useEffect} from 'react';
import StylesType from '@/types/StylesType';
import DeviceContainer from './DeviceContainer';
import { Row, Col } from 'antd';
import classnames from 'classnames';
import * as R from 'ramda';
import {View} from '@/components'

import './style';

interface DeviceListProps extends StylesType{
  dataSource: any []
  selectOptions: any,
  onChange: (e: any) => void
}

const DeviceList: React.FC<DeviceListProps> = props => {
  
  const {dataSource, prefixCls, selectOptions, onChange} = props;
  
  const { checkedList } = selectOptions;
  
  useEffect(() => {
  },)
  
  return (
   <View.ScrollView backTop={true} bottomHeight={78}>
     <Row type='flex' className={classnames(prefixCls)} gutter={[16, 16]}>
       {dataSource.map(item => <Col key={item.id}><DeviceContainer onChange={onChange} checked={R.includes(item.cid,checkedList)} options={item} /></Col>)}
     </Row>
   </View.ScrollView>
  )
  
}

DeviceList.defaultProps = {
  prefixCls: 'gc-device-list'
}

export default DeviceList;
